const inMissionStatesMap = new Map([
  ['0', 'Sin asignar'],
  ['1', 'En servicio'],
  [0, 'Sin asignar'],
  [1, 'En servicio'],
  [false, 'Sin asignar'],
  [true, 'En servicio']
])

export {inMissionStatesMap}



// WEBPACK FOOTER //
// ./src/utils/inMissionStates.js